import {
  BarChart3,
  ClipboardList,
  FileSpreadsheet,
  LayoutDashboard,
  MessageSquare,
  Search,
  Settings,
  ShoppingCart,
  Users,
} from "lucide-react";

import type { Role } from "../types";

export const navItems = [
  { label: "Dashboard", mobileLabel: "Home", icon: LayoutDashboard },
  { label: "Marketplace", mobileLabel: "Market", icon: ShoppingCart },
  { label: "Orders", mobileLabel: "Orders", icon: ClipboardList },
  { label: "Invoices", mobileLabel: "Invoice", icon: FileSpreadsheet },
  { label: "Suppliers", mobileLabel: "Supply", icon: Users },
  { label: "Supplier Finder", mobileLabel: "Find", icon: Search },
  { label: "Network Intel", mobileLabel: "Intel", icon: BarChart3 },
  { label: "Messages", mobileLabel: "Inbox", icon: MessageSquare },
  { label: "Analytics", mobileLabel: "Stats", icon: FileSpreadsheet },
  { label: "Settings", mobileLabel: "Setup", icon: Settings },
];

export type WorkspaceNavItem = (typeof navItems)[number];

export function navItemsForRole(role: Role) {
  const allowed: Record<Role, string[]> = {
    restaurant: ["Dashboard", "Marketplace", "Orders", "Invoices", "Messages", "Settings"],
    supplier: ["Dashboard", "Orders", "Suppliers", "Invoices", "Supplier Finder", "Messages", "Settings"],
    admin: ["Dashboard", "Network Intel", "Supplier Finder", "Suppliers", "Messages", "Analytics", "Settings"],
  };

  return navItems.filter((item) => allowed[role].includes(item.label));
}

export function navDisplayLabel(item: WorkspaceNavItem, role: Role) {
  if (role === "supplier") {
    const labels: Record<string, string> = {
      Dashboard: "Today",
      Orders: "Orders",
      Suppliers: "Products",
      Invoices: "Invoices",
      "Supplier Finder": "Restaurant leads",
      Messages: "Inbox",
      Analytics: "Sales",
      Settings: "Setup",
    };

    return labels[item.label] ?? item.label;
  }

  if (role !== "restaurant") {
    return item.label;
  }

  const labels: Record<string, string> = {
    Dashboard: "Today",
    Marketplace: "Suppliers",
    Orders: "Orders",
    Invoices: "Invoices",
    Messages: "Inbox",
    Analytics: "Money",
    Settings: "Setup",
  };

  return labels[item.label] ?? item.label;
}

export function navMobileDisplayLabel(item: WorkspaceNavItem, role: Role) {
  if (role === "supplier") {
    const labels: Record<string, string> = {
      Dashboard: "Today",
      Orders: "Orders",
      Suppliers: "Products",
      Invoices: "Invoice",
      "Supplier Finder": "Leads",
      Messages: "Inbox",
      Analytics: "Sales",
      Settings: "Setup",
    };

    return labels[item.label] ?? item.mobileLabel;
  }

  if (role !== "restaurant") {
    return item.mobileLabel;
  }

  const labels: Record<string, string> = {
    Dashboard: "Today",
    Marketplace: "Suppliers",
    Orders: "Orders",
    Invoices: "Invoice",
    "Supplier Finder": "Suppliers",
    Messages: "Inbox",
    Analytics: "Spend",
    Settings: "Setup",
  };

  return labels[item.label] ?? item.mobileLabel;
}
